/** @format */

import { AxiosError, AxiosResponse } from "axios";
import { API_ENDPOINTS } from "../../constants/api";
import { TBranchCreateRequest } from "../../redux-modules/declarations/maps/branch";
import apiClient from "../../utils/apiClient";

export const apiBranchCreate = (
  data: TBranchCreateRequest,
): Promise<{ response?: AxiosResponse; error?: AxiosError }> =>
  apiClient
    .post(API_ENDPOINTS.BRANCH, data)
    .then(response => ({ response }))
    .catch(error => ({ error }));
